import * as dgtTest from '../services/dgtTest';

export default {
  namespace: 'dgtTest',

  state: {
    GraphList: null,
    getSearch: null,
    getImplement: null,
    editRuleManaList: null,
    deleteRuleManaList: null,
    getGraphInputList: null,
    getGraphOutputList: null,
  },

  effects: {
    *getGraphTable({ payload: {}, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.getGraphTable);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          GraphList: response,
        },
      });
    },

    *getSearch({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.getSearch, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          getSearch: response,
        },
      });
    },

    *getImplement({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.getImplement, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          getImplement: response,
        },
      });
    },

    *editRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.editRuleManaList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editRuleManaList: response,
        },
      });
    },
    *deleteRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.deleteRuleManaList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleManaList: response,
        },
      });
    },

    *getGraphInputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.getGraphInputList, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          getGraphInputList: response,
        },
      });
    },
    *getGraphOutputList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(dgtTest.getGraphOutputList, values);
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
      yield put({
        type: 'save',
        payload: {
          getGraphOutputList: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
